import * as actionTypes from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* Send Post Request                                                                              */
/*------------------------------------------------------------------------------------------------*/
/**
 * sendRequest
 * API Posts the request.
 * @param { Object } request: the request object.
 * @returns { Object } action.
 */
export const sendRequest = (request) => ({
  type: actionTypes.SEND_POST_REQUEST,
  request,
});

/**
 *
 * @param { Object } response: response from the API.
 * @returns { Object } action.
 */
export const fetchResponse = ({ response, route }) => ({
  type: actionTypes.SEND_POST_RESPONSE,
  route,
  response,
});
